import { render, staticRenderFns } from "./user-center.vue?vue&type=template&id=7ce24d92&scoped=true"
import script from "./user-center.vue?vue&type=script&lang=js"
export * from "./user-center.vue?vue&type=script&lang=js"
import style0 from "./user-center.vue?vue&type=style&index=0&id=7ce24d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce24d92",
  null
  
)

export default component.exports